import React from "react";
import { Button } from "primereact/button";
import "./InGameButton.css";


export default function InGameButton({img, onClick}){
    return <Button className="inGameButton" onClick={onClick} rounded >
        <img alt="logo" src={img} width="50px"/>
    </Button>
}